module.exports = __webpack_public_path__ + "static/media/delantal (8).62b51a22.jpg";